// Theme: mono
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'mono',
  name: 'MONO',
  tagline: 'MONO',
  description: 'Preto e branco absoluto. Foco total, zero cor.',
  category: 'minimal-atmosphere',
  tier: 'common',
  basePrice: 200,
  swatches: ['#1A1A1A', '#FFFFFF', '#252525', '#D4D4D4'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '4px',
      '--shadow-card': 'none',
      '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-mono'
  },
  colorVars: {
    '--accent': '#6B6B6B',
    '--accent-foreground': '#1A1A1A',
    '--background': '#1A1A1A',
    '--border': '#6B6B6B',
    '--card': '#252525',
    '--card-border-active': 'rgba(255, 255, 255, 0.08)',
    '--card-completed': '#2D2D2D',
    '--card-foreground': '#D4D4D4',
    '--card-glow': 'rgba(255, 255, 255, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1A1A',
    '--foreground': '#D4D4D4',
    '--hold-fill': '#FFFFFF',
    '--input': '#252525',
    '--modal-bg': '#1A1A1A',
    '--modal-border': '#6B6B6B',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#252525',
    '--muted-foreground': '#6B6B6B',
    '--nav-active': '#FFFFFF',
    '--nav-bg': '#1A1A1A',
    '--popover': '#252525',
    '--popover-foreground': '#D4D4D4',
    '--primary': '#FFFFFF',
    '--primary-foreground': '#1A1A1A',
    '--ring': '#FFFFFF',
    '--secondary': '#6B6B6B',
    '--secondary-foreground': '#D4D4D4',
    '--streak': '#FFFFFF',
    '--success': '#22c55e',
    '--success-foreground': '#1A1A1A',
    '--xp': '#FFFFFF',
    '--xp-bg': '#252525'
  },
  resolvedVars: {
    '--accent': '#6B6B6B',
    '--accent-foreground': '#1A1A1A',
    '--accent-foreground-hsl': '0 0% 10%',
    '--accent-foreground-oklch': 'from #1A1A1A l c h',
    '--accent-hsl': '0 0% 42%',
    '--accent-oklch': 'from #6B6B6B l c h',
    '--background': '#1A1A1A',
    '--background-hsl': '0 0% 10%',
    '--background-oklch': 'from #1A1A1A l c h',
    '--border': '#6B6B6B',
    '--border-hsl': '0 0% 42%',
    '--border-oklch': 'from #6B6B6B l c h',
    '--border-w': '2px',
    '--card': '#252525',
    '--card-border-active': 'rgba(255, 255, 255, 0.08)',
    '--card-completed': '#2D2D2D',
    '--card-completed-hsl': '0 0% 18%',
    '--card-completed-oklch': 'from #2D2D2D l c h',
    '--card-foreground': '#D4D4D4',
    '--card-foreground-hsl': '0 0% 83%',
    '--card-foreground-oklch': 'from #D4D4D4 l c h',
    '--card-glow': 'rgba(255, 255, 255, 0.08)',
    '--card-hsl': '0 0% 15%',
    '--card-oklch': 'from #252525 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1A1A',
    '--destructive-foreground-hsl': '0 0% 10%',
    '--destructive-foreground-oklch': 'from #1A1A1A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D4D4D4',
    '--foreground-hsl': '0 0% 83%',
    '--foreground-oklch': 'from #D4D4D4 l c h',
    '--hold-fill': '#FFFFFF',
    '--hold-fill-hsl': '0 0% 100%',
    '--hold-fill-oklch': 'from #FFFFFF l c h',
    '--input': '#252525',
    '--input-hsl': '0 0% 15%',
    '--input-oklch': 'from #252525 l c h',
    '--modal-bg': '#1A1A1A',
    '--modal-bg-hsl': '0 0% 10%',
    '--modal-bg-oklch': 'from #1A1A1A l c h',
    '--modal-border': '#6B6B6B',
    '--modal-border-hsl': '0 0% 42%',
    '--modal-border-oklch': 'from #6B6B6B l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#252525',
    '--muted-foreground': '#6B6B6B',
    '--muted-foreground-hsl': '0 0% 42%',
    '--muted-foreground-oklch': 'from #6B6B6B l c h',
    '--muted-hsl': '0 0% 15%',
    '--muted-oklch': 'from #252525 l c h',
    '--nav-active': '#FFFFFF',
    '--nav-active-hsl': '0 0% 100%',
    '--nav-active-oklch': 'from #FFFFFF l c h',
    '--nav-bg': '#1A1A1A',
    '--nav-bg-hsl': '0 0% 10%',
    '--nav-bg-oklch': 'from #1A1A1A l c h',
    '--popover': '#252525',
    '--popover-foreground': '#D4D4D4',
    '--popover-foreground-hsl': '0 0% 83%',
    '--popover-foreground-oklch': 'from #D4D4D4 l c h',
    '--popover-hsl': '0 0% 15%',
    '--popover-oklch': 'from #252525 l c h',
    '--primary': '#FFFFFF',
    '--primary-foreground': '#1A1A1A',
    '--primary-foreground-hsl': '0 0% 10%',
    '--primary-foreground-oklch': 'from #1A1A1A l c h',
    '--primary-hsl': '0 0% 100%',
    '--primary-oklch': 'from #FFFFFF l c h',
    '--radius': '4px',
    '--ring': '#FFFFFF',
    '--ring-hsl': '0 0% 100%',
    '--ring-oklch': 'from #FFFFFF l c h',
    '--secondary': '#6B6B6B',
    '--secondary-foreground': '#D4D4D4',
    '--secondary-foreground-hsl': '0 0% 83%',
    '--secondary-foreground-oklch': 'from #D4D4D4 l c h',
    '--secondary-hsl': '0 0% 42%',
    '--secondary-oklch': 'from #6B6B6B l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FFFFFF',
    '--streak-hsl': '0 0% 100%',
    '--streak-oklch': 'from #FFFFFF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1A1A',
    '--success-foreground-hsl': '0 0% 10%',
    '--success-foreground-oklch': 'from #1A1A1A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(0 0% 100% / 0.15)',
    '--xp': '#FFFFFF',
    '--xp-bg': '#252525',
    '--xp-bg-hsl': '0 0% 15%',
    '--xp-bg-oklch': 'from #252525 l c h',
    '--xp-hsl': '0 0% 100%',
    '--xp-oklch': 'from #FFFFFF l c h'
  }
}
